import moment from "moment";

export const mapTramoToAuditData = (tramo, parentRow = {}) => {
  const provinciaOrigen = tramo.provinciaOrigen || "";
  const localidadOrigen = tramo.localidadOrigen || "";
  const provinciaDestino = tramo.provinciaDestino || "";
  const localidadDestino = tramo.localidadDestino || "";

  return {
    idTramo: tramo.idTramo,
    idTraslado: tramo.nroTraslado ?? tramo.idTraslado ?? parentRow.nroTraslado,
    nroOrden: tramo.nroOrden,
    cantidadTramos: tramo.cantidadTramos ?? parentRow.tramos?.length ?? 1,
    esRetorno: tramo.esRetorno,
    trabajador: parentRow.trabajador ?? tramo.trabajador,
    siniestro: String(tramo.siniestro ?? parentRow.siniestro ?? ""),
    idSiniestro: tramo.idSiniestro ?? parentRow.idSiniestro,
    nroFormulario: tramo.nroFormulario ?? parentRow.nroFormulario,
    idArt: tramo.idArt ?? parentRow.idArt,
    prestadorId: tramo.prestadorId ?? parentRow.prestadorId,
    origen:
      tramo.origen ||
      [provinciaOrigen, localidadOrigen].filter(Boolean).join(" - "),
    destino:
      tramo.destino ||
      [provinciaDestino, localidadDestino].filter(Boolean).join(" - "),
    latOrigen: tramo.latOrigen,
    lngOrigen: tramo.lngOrigen,
    latDestino: tramo.latDestino,
    lngDestino: tramo.lngDestino,
    fechaTraslado: tramo.fechaHoraTraslado,
    horaTraslado:
      tramo.horaTraslado ||
      (tramo.fechaHoraTraslado
        ? moment(tramo.fechaHoraTraslado).format("HH:mm")
        : ""),
    dni: tramo.dni ?? parentRow.documentoTrabajador ?? tramo.documentoTrabajador,
    gestor: tramo.gestor ?? parentRow.gestor,
    transporte: tramo.transporte ?? tramo.tipoTransporteNombre,
    idAgencia: tramo.idAgencia,
    idMotivoTraslado: tramo.idMotivoTraslado,
    agencia: tramo.agenciaNombre,
    estado: tramo.estadoTramoNombre,
    idEstado: tramo.estadoTramoId,
    posibleNegativo: tramo.posibleNegativo,
    idArt: tramo.idArt ?? parentRow.idArt,
    idSiniestro: tramo.idSiniestro ?? parentRow.idSiniestro,
    nroFormulario: tramo.nroFormulario ?? parentRow.nroFormulario,
    apellidoTrabajador: tramo.apellidoTrabajador ?? parentRow.apellidoTrabajador,
    nombreTrabajador: tramo.nombreTrabajador ?? parentRow.nombreTrabajador,
    numeroHistoriaClinica:
      tramo.numeroHistoriaClinica ?? parentRow.numeroHistoriaClinica ?? tramo.siniestro,
    alarmas: tramo.alarmas ?? [],
    motivoRech: tramo.motivoRech,
    horaLlegada: tramo.horaLlegada,
    informadoPor: tramo.informadoPor,
    motivoNegativo: tramo.motivoNegativo,
    observacionesNegativo: tramo.observacionesNegativo,
  };
};
